import * as React from 'react';
import classnames from 'classnames';
import { UIText2 } from '@cian/ui-kit';

import { IMoneySourceTabProps } from '../../types';
import { getTextColor } from './utils';
import * as styles from './MoneySourceTab.css';

export const MoneySourceTab = ({ active, label, disabled, handleClick }: IMoneySourceTabProps) => (
  <div
    className={classnames(styles['tab'], disabled && styles['disabled'], active && styles['active'])}
    data-checked={active}
    onClick={handleClick}
  >
    <UIText2 color={getTextColor(disabled, active)} fontWeight="700">
      {label}
    </UIText2>
  </div>
);
